














































































import { DataImportFile } from '@/shared/data-import-file';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const usersModule = namespace('users');

@Component
export default class ViewDataImportDialog extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private dataImportFile!: DataImportFile;

    private isVisible: boolean = this.visible;

    private get statusDescription(): string {
        switch (this.dataImportFile.status) {
            case 0:
                return 'Pending';
            case 1:
                return 'In Progress';
            case 2:
                return 'Failed';
            case 3:
                return 'Succeeded';
            default:
                return '';
        }
    }

    private get typeDescription(): string {
        switch (this.dataImportFile.type) {
            case 0:
                return 'New Data';
            case 1:
                return 'Cleansed Data';
            case 2:
                return 'Pipeline Data';
            default:
                return '';
        }
    }

    private get userDescription(): string {
        const user = this.users.find((u) => u.id === this.dataImportFile.createdBy);
        return user == null ? '' : `${user.firstName == null ? '' : user.firstName.trim()} ${user.lastName == null ? '' : user.lastName.trim()}`;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
